// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const MatrixOut = zod.object({
  "threshold": zod.int()
});

export type MatrixOut = zod.input<typeof MatrixOut>;
export type MatrixOutOutput = zod.output<typeof MatrixOut>;
